"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvConfigServiceV1Impl = void 0;
const await_semaphore_1 = require("await-semaphore");
const urlTemplate = require("url-template");
class EnvConfigServiceV1Impl {
    constructor(options, logger) {
        this.options = options;
        this.logger = logger;
        this.cache = new Map();
        this.mutexs = new Map();
        this.template = urlTemplate.parse(this.options.templateUrl);
    }
    createUrlFromTemplate(key) {
        return this.template.expand({ key });
    }
    async getConfiguration(key) {
        // create mutex, so that same key does not get fetched twice via fetch
        const mutex = this.mutexs.get(key) || new await_semaphore_1.Mutex();
        this.mutexs.set(key, mutex);
        return mutex.use(async () => {
            // returns cached promise if it already exists.
            const cached = this.cache.get(key);
            if (cached) {
                return cached;
            }
            // try to fetch configuration based on key from env-config endpoint
            try {
                const response = await fetch(this.createUrlFromTemplate(key));
                // a non-200 status code resolves to undefined and even gets cached.
                let result;
                if (response.status === 200) {
                    result = response.json();
                }
                else {
                    result = Promise.resolve(undefined);
                    this.logger.warn(`Loading of key '${key}' returned status code ${response.status} (${response.statusText}).`);
                }
                // cache promise for consecutive requests
                this.cache.set(key, result);
                return result;
            }
            catch (e) {
                this.logger.error(`Loading of key '${key}' failed: ${e}`);
                return Promise.resolve(undefined);
            }
        });
    }
}
exports.EnvConfigServiceV1Impl = EnvConfigServiceV1Impl;
//# sourceMappingURL=EnvConfigServiceV1.js.map